import React from "react";
import FormSelectField, {FormSelectFieldProps} from "./FormSelectField";
import {Grid, MenuItem} from "@mui/material";
import {ListQuery, ListRequest, ListResponseType} from "../../app/api/types";
import {skipToken} from "@reduxjs/toolkit/dist/query";
import {useTranslation} from "react-i18next";
import {GridTypeMap} from "@mui/material/Grid/Grid";

export interface SelectRequestFieldProps<T extends ListResponseType, V, U extends ListRequest>
    extends Omit<FormSelectFieldProps<V>, "children"> {
    query: ListQuery<T, U>;
    request: U;
    skip?: boolean;
    valueField?: keyof T;
    optionLabelField?: keyof T;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
}

const FormSelectListRequestField = <T extends ListResponseType, V, U extends ListRequest>({
    query,
    skip,
    request,
    valueField,
    optionLabelField,
    isGridItem,
    gridProps,
    ...rest
}: SelectRequestFieldProps<T, V, U>) => {
    const {t} = useTranslation();
    const {data: response} = query(skip ? skipToken : request);
    const renderField = () => (
        <FormSelectField {...rest}>
            {response?.payload?.map((r: any) => {
                const value = typeof r === "string" ? r : r[valueField || "id"];
                return (
                    <MenuItem key={value} value={value}>
                        {optionLabelField && typeof r !== "string" ? r[optionLabelField] : value}
                    </MenuItem>
                );
            }) || <MenuItem value="">{t("generic_notAvailable")}</MenuItem>}
        </FormSelectField>
    );

    return isGridItem ? (
        <Grid item {...gridProps}>
            {renderField()}
        </Grid>
    ) : (
        renderField()
    );
};

export default FormSelectListRequestField;
